import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/**
 * Enable ajax loading of views (reduces the size of the initial download)
 * @param {string} view
 */
function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: loadView('Home'),
      meta: {
        title: 'Current Opportunities',
        public: true,
      },
    },
    {
      name: 'job/view',
      path: '/job/:ref',
      component: loadView('job/View'),
      meta: {
        title: 'Job Details',
        public: true,
      },
    },
    {
      name: 'job/apply',
      path: '/job/:ref/apply',
      component: loadView('job/Apply'),
      meta: {
        title: 'Apply for job',
      },
    },
    {
      name: 'job-application/view',
      path: '/job-application/:ref',
      component: loadView('job-application/View'),
      meta: {
        title: 'Job Application',
      },
    },
    {
      name: 'job-application/view/medical',
      path: '/job-application/:ref/medical',
      component: loadView('job-application/View'),
      meta: {
        title: 'Medical - Job Application',
      },
    },
    {
      name: 'job-application/view/medical/nights',
      path: '/job-application/:ref/medical/nights',
      component: loadView('job-application/View'),
      meta: {
        title: 'Nights - Job Application',
      },
    },
    {
      path: '/register',
      component: loadView('register/Register'),
      meta: {
        title: 'Register new account',
        public: true,
      },
      children: [
        {
          name: 'register/start-over',
          path: 'start-over',
          component: loadView('register/Register'),
          meta: {
            title: 'Register new account',
            public: true,
          },
        },
        {
          name: 'register/step1',
          path: 'step1',
          component: loadView('register/Step1'),
          meta: {
            title: 'Enter your details',
            public: true,
          },
        },
        {
          name: 'register/step2',
          path: 'step2',
          component: loadView('register/Step2'),
          meta: {
            title: 'Verify your email address',
            public: true,
          },
        },
        {
          name: 'register/step3',
          path: 'step3',
          component: loadView('register/Step3'),
          meta: {
            title: 'Account confirmed - sign in below',
            public: true,
          },
        },
        {
          // default child route
          path: '',
          name: 'register',
          redirect: 'step1',
        },
      ],
    },
    {
      name: 'my-applications',
      path: '/my-applications',
      component: loadView('MyApplications'),
      meta: {
        title: 'Your Applications',
      },
    },
    {
      name: 'user-basic-profile',
      path: '/home/my-contact-details',
      component: loadView('user/BasicProfile'),
      meta: {
        title: 'Your Contact Details',
      },
    },
    {
      path: '/home/job-application-profile',
      component: loadView('job-application-profile/JobApplicationProfile'),
      meta: {
        title: 'Job Application Profile',
      },
      children: [
        {
          name: 'job-application-profile/about-you',
          path: 'about-you',
          component: loadView('job-application-profile/AboutYou'),
          meta: {
            title: 'About You',
          },
        },
        {
          name: 'job-application-profile/address-history',
          path: 'address-history',
          component: loadView('job-application-profile/AddressHistory'),
          meta: {
            title: 'Address History',
          },
        },
        {
          name: 'job-application-profile/employment-history',
          path: 'employment-history',
          component: loadView('job-application-profile/EmploymentHistory'),
          meta: {
            title: 'Employment History',
          },
        },
        {
          name: 'job-application-profile/experience',
          path: 'experience',
          component: loadView('job-application-profile/Experience'),
          meta: {
            title: 'Experience',
          },
        },
        {
          name: 'job-application-profile/qualifications',
          path: 'qualifications',
          component: loadView('job-application-profile/Qualifications'),
          meta: {
            title: 'Qualifications',
          },
        },
        {
          name: 'job-application-profile/references',
          path: 'references',
          component: loadView('job-application-profile/References'),
          meta: {
            title: 'References',
          },
        },
        {
          // default child route
          path: '',
          name: 'user-details',
          redirect: 'about-you',
        },
      ],
    },
    {
      name: 'sign-in',
      path: '/sign-in',
      component: loadView('MyApplications'),
      meta: {
        title: 'Sign in or register',
      },
    },
    {
      name: 'sign-in-pin',
      path: '/sign-in/pin',
      component: loadView('PinLogin'),
      meta: {
        title: 'Sign in with PIN code',
      },
    },
    {
      name: 'privacy',
      path: '/privacy',
      // Todo this is a placeholder
      component: loadView('MyApplications'),
      meta: {
        title: 'Privacy, Security and Terms of Use',
      },
    },
  ],
});

export default router;
